module.exports = __webpack_public_path__ + "static/media/nirmal-500.d01ed44f.png";